import { Checkbox } from "@mantine/core";
import { useAddToWatchlistMutation, useMyWatchlistSuspense, useRemoveFromWatchlistMutation } from "../queries";

export const WatchlistCheckbox: React.FC<{ studentNo: string }> = ({ studentNo }) => {
    
    const { data: watchlist } = useMyWatchlistSuspense()

    const remove = useRemoveFromWatchlistMutation();
    const add = useAddToWatchlistMutation()

    return (
        <Checkbox
            label='Watchlist'
            checked={watchlist?.some(w => w.studentNumber === studentNo) ?? false}
            size='xs'
            onChange={(e) => {
                e.preventDefault()
                e.stopPropagation()
                if (e.currentTarget.checked) {
                    add.mutate(studentNo);
                } else {                    
                    remove.mutate(studentNo);
                }
            }}
        />
    );
}